<template>
  <div class="stock">
    <ly-header></ly-header>
    <div class="content">
      <div class="left">
        <div class="l-top">
          <div class="btns">
            <div v-for="(item,index) of openbig" 
                :key="index" 
                @click="HandleBig(index+1)"
                :class="{'on' : initopen == index+1}"
            >{{item}}</div>
          </div>
          <ul class="l-top-title">
            <li>
              物料名称：
              <input type="text" class="searchs" />
              <button>查询</button>
            </li>
            <li>
              列:
              <select v-model="initLie">
                <option v-for="item of 57" :key="item">第{{item}}列</option>
              </select>
              层:
              <select v-model="initCeng">
                <option v-for="items of 14" :key="items">第{{items}}层</option>
              </select>
              <button @click="HandleSearch()">查询</button>
            </li>
          </ul>
          <li class="nav-title">
            <ul class="title1">
              <li
                v-for="(item,index) of 6"
                :key="index"
                @click="HandleNav(index+1)"
                :class="{'on' : initNum == index+1}"
              >{{index+1}}排</li>
            </ul>
            <ul class="title2">
              <li>
                <i></i>
                <span>托盘组</span>
              </li>
              <li>
                <i></i>
                <span>实托盘</span>
              </li>
            </ul>
          </li>
          <div class="l-top-nav" ref="parent">
            <div class="shelves" @mousedown="drag" ref="child" :class="{'KeyCord':isShow}" :style="shelvesStyle.parent[initopen-1]">
              <div 
                :style="shelvesStyle.child[initopen-1]"
                v-for="(item,index) of dataList"
                :key="index"
                @dblclick.stop="HandleClick(
                  item.ShelfGridNo,     //货架号
                  item.ShelfGridFlagName,   //货位标记
                  item.ShelfGridStateName,    //货位状态
                  item.MaterialName,    //物料名称
                  item.MaterialState,   //物料状态
                  item.MaterialType,    //物料类型
                  )"
                :class="{
                  'state-jy' : item.ShelfGridFlag == 4,
                  'state-zs' : item.ShelfGridFlag == 5,
                  'state-kcbkr' : item.ShelfGridFlag == 3,
                  'state-krbkc' : item.ShelfGridFlag == 2,
                  'state-ky' : item.ShelfGridFlag == 1,   //货位标记

                  'state1-drk' : item.ShelfGridState == 1,
                  'state1-dck' : item.ShelfGridState == 2,
                  'state1-ycc' : item.ShelfGridState == 3,
                  'state1-k' : item.ShelfGridState == 5,
                  'state1-bl' : item.ShelfGridState == 4,   //货位状态
                  }" 
                
              >
              <div 
                  :style="shelvesStyle.children[initopen-1]"
                  :class="{
                    'state-tpz' : item.MaterialType == 1,
                    'state-stp' : item.MaterialType == 2,
              }"></div>
              </div>
            </div>
          </div>
          <ul class="l-top-bottom">
            <li>
              <input type="checkbox" name id :checked="isShow" @click="HandleCheck()"/>货位状态
              <ul class="hwzt">
                <li v-for="lists of hwzt" :key="lists"><i></i>{{lists}}</li>
              </ul>
            </li>
            <li>
              <input type="checkbox" name id :checked="!isShow" @click="HandleCheck()"/>货位标记
              <ul class="hwbj">
                <li v-for="list of hwbj" :key="list"><i></i>{{list}}</li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="l-bottom">
          <div class="div1">
            <!-- 库区储存总量 -->
            <stock-total></stock-total>
          </div>
          <div class="div2">
            <!-- 库存信息 -->
            <stock-infor></stock-infor>
          </div>
          <div class="div1">
            <!-- 账实相符率 -->
            <stock-detail></stock-detail>
          </div>
          <div class="div2">
            <!-- 查询信息 -->
            <search-infor></search-infor>
          </div>
        </div>
      </div>
      <div class="right">
        <div>
          <stock-utilization></stock-utilization>
        </div>
        <div>
          <material-proportion></material-proportion>
        </div>
        <div>
          <marking-status></marking-status>
        </div>
        <div>
          <warning-record :table34Data="table34Data"></warning-record>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 库存管理
import LyHeader from "./common/Header";
import MarkingStatus from "./home/echarts32"; //货位标记/状态
import StockUtilization from "./home/echarts31"; //利用率/周转率
import StockInfor from "./home/echarts28"; //库存信息
import StockTotal from "./home/echarts27"; //库区总量
import StockDetail from "./home/echarts29"; //账实相符率
import SearchInfor from "./home/echarts30"; //查询信息

import MaterialProportion from "./home/echarts33"; //物料占比/库龄分布
import WarningRecord from "./home/echarts34"; //预警记录
export default {
  name: "Stock",
  data() {
    return {
      openbig:["原始","1倍","2倍"],
      initopen:1,
      hwzt:["待入库","待出库","已储存","空","保留"],
      hwbj:["禁用","阻塞","可出不可入","可入不可出","可用"],
      initCeng: "第1层",
      initLie: "第1列",
      dataList: [],
      ShelfNo:1,
      initNum:1,
      table34Data:[],
      shuju:[],
      state:true,
      isShow:true,     // 货位标记/货位状态开关
      shelvesStyle:{
        parent:[
          {width: "900px", height: "246px",left: "15px",top: "77px"},
          {width: "1800px", height: "492px",},
          {width: "2700px", height: "738px",},
        ],
        child:[
          {width: "10px", height: "10px",margin:"7px 0 0 3px"},
          {width: "20px", height: "20px",margin:"14px 0 0 6px"},
          {width: "30px", height: "30px",margin:"21px 0 0 9px"},
        ],
        children:[
          {width: "7px", height: "7px"},
          {width: "14px", height: "14px"},
          {width: "21px", height: "21px"},
        ]
      }
    };
  },
  components: {
    LyHeader,
    MarkingStatus,
    StockUtilization,
    StockInfor,
    StockTotal,
    StockDetail,
    SearchInfor,
    WarningRecord,
    MaterialProportion
  },
  methods: {
    HandleBig(num){   //放大
      this.initopen = num;
    },
    HandleCheck(){    //  货位状态/货位标记选择
      this.isShow = !this.isShow;
      console.log(this.isShow)
    },
    HandleSearch(){
      var lie, ceng;
      if (this.initLie.length == 3) {
        lie = this.initLie.slice(1, 2) * 1;
      }
      if (this.initLie.length == 4) {
        lie = this.initLie.slice(1, 3) * 1;
      }
      if (this.initCeng.length == 3) {
        ceng = this.initCeng.slice(1, 2) * 1;
      }
      if (this.initCeng.length == 4) {
        ceng = this.initCeng.slice(1, 3) * 1;
      }
      var total = (lie-1) * 14 + ceng;

      var shelfGridNo = "货架编号：" +this.dataList[total-1].ShelfGridNo;
      var shelfGridFlagName = "货位标记：" +this.dataList[total-1].ShelfGridFlagName;
      var shelfGridStateName = "货位状态：" +this.dataList[total-1].ShelfGridStateName;
      var materialName = "物料名称："+this.dataList[total-1].MaterialName;
      var materialState = "物料状态："+this.dataList[total-1].MaterialState;
      var type = this.dataList[total-1].MaterialType;
      var materialType;
      if(type == 1){
        materialType = "物料类型："+"托盘组"
      }else if(type == 2){
        materialType = "物料类型："+"实托盘"
      }else{
        materialType = "物料类型："+"空"
      }
      this.$alert(
        shelfGridNo+'</br>'+
        shelfGridFlagName+'</br>'+
        shelfGridStateName+'</br>'+
        materialName+'</br>'+
        materialState+'</br>'+
        materialType+'</br>',
         shelfGridNo,
        {
        dangerouslyUseHTMLString: true
      });

    },
    HandleNav(num){   //货架切换
      this.ShelfNo = num;
      this.initNum = num;
      this.GetData();
    },
    drag(e) {
      var oDiv = e.path[0];
      var parentH = this.$refs.parent.offsetHeight; //父元素高度
      var parentW = this.$refs.parent.offsetWidth; //父元素宽度

      var childH = this.$refs.child.offsetHeight; //子元素高度
      var childW = this.$refs.child.offsetWidth; //子元素宽度

      var limitLeft = 50 - childW;
      var limitRight = parentW - 50;
      var limitTop = 50 - childH;
      var limitBottom = parentH - 50;

      var disX = e.clientX - oDiv.offsetLeft;
      var disY = e.clientY - oDiv.offsetTop;

      document.onmousemove = function(e) {
        e.preventDefault();
        var l = e.clientX - disX;
        var t = e.clientY - disY;

        if (l < 0 && l > limitLeft) {
          //left 限制
          oDiv.style.left = l + "px";
        }
        if (t < 0 && t > limitTop) {
          //top 限制拖拽
          oDiv.style.top = t + "px";
        }
        if (l > 0 && l < limitRight) {
          //right 限制拖拽
          oDiv.style.left = l + "px";
        }
        if (t > 0 && t < limitBottom) {
          //bottom 限制拖拽
          oDiv.style.top = t + "px";
        }
      };
      document.onmouseup = function() {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    bubbleSort(arr) {
      //排序
      if (arr.length <= 1) return;
      for (let i = 0; i < arr.length; i++) {
        let flag = false; // 提前退出冒泡的标志
        for (let j = 0; j < arr.length - i - 1; j++) {
          if (arr[j].ShelfGridNo > arr[j + 1].ShelfGridNo) {
            let tmp = arr[j];
            arr[j] = arr[j + 1];
            arr[j + 1] = tmp;
            flag = true;
          }
        }
        if (!flag) break;
      }
      return arr;
    },
    GetData() {
      //数据
      let _this = this;
      this.$handleRequest(
        window.ApiHost1 + "/api/DataStatistical/Inv_Info",
        {
          ShowEmptyTray: true,
          IsGetTotalCount: false,
          ShelfNo: this.ShelfNo,
          MaterialCode: "",
          GoodsBatchNo: "",
          WareHouseCode: window.PYKWareHouseCode,
        },
        "post",
        function(res) {
          //success
          console.log(res.retData);
          _this.dataList = res.retData.Rows;
          _this.dataList = _this.bubbleSort(_this.dataList);
        },
        function(res) {
          //fail
          console.log("请求异常");
        }
      );
    },
    getLyl(){   // 预警记录
      let _this = this;
      this.$handleRequest(
        window.ApiHost1 + "/api/DataStatistical/Inv_EarlyWarnnings_Info",
        {
          WareHouseCode: window.PYKWareHouseCode
        },
        "post",
        function(res) {
          //success
          _this.table34Data = res.retData.Rows
        
        },
        function(res) {
          //fail
          console.log("请求异常");
        }
      );
    },
    getWlKc(){    //库存/物料占比
      let _this = this;
      this.$handleRequest(
        window.ApiHost1 + "/api/DataStatistical/Inv_EarlyWarnnings_Info",
        {
          WareHouseCode: window.PYKWareHouseCode
        },
        "post",
        function(res) {
          //success
          _this.shuju = res.retData.Rows
          console.log(res.retData.Rows);
        
        },
        function(res) {
          //fail
          console.log("请求异常");
        }
      );
    },
    HandleClick(ShelfGridNo,ShelfGridFlagName,ShelfGridStateName,MaterialName,MaterialState,MaterialType) {
      var shelfGridNo = "货架编号：" +ShelfGridNo;
      var shelfGridFlagName = "货位标记：" +ShelfGridFlagName;
      var shelfGridStateName = "货位状态：" +ShelfGridStateName;
      var materialName = "物料名称："+MaterialName;
      var materialState = "物料状态："+MaterialState;
      var materialType;
      if(MaterialType == 1){
        materialType = "物料类型："+"托盘组";
      }else if(MaterialType == 2){
        materialType = "物料类型："+"实托盘";
      }else{
        materialType = "物料类型："+"空";
      }

      this.$alert(
        shelfGridNo+'</br>'+
        shelfGridFlagName+'</br>'+
        shelfGridStateName+'</br>'+
        materialName+'</br>'+
        materialState+'</br>'+
        materialType+'</br>',
         shelfGridNo,
        {
        dangerouslyUseHTMLString: true
      });
    }
  },
  mounted() {
    this.GetData();
    this.getLyl();
  }
};
</script>


<style scoped>
.stock {
  width: 1918px;
  height: 853px;
  margin: 0 auto;
  position: relative;
  background-color: #348975;
  overflow: hidden;
}
.content {
  height: calc(100% - 134px);
  padding: 10px 10px;
  margin-top: 114px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left {
  width: 1000px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.l-top {
  height: 557px;
  background-color: #00665e;
  overflow: hidden;
  position: relative;
}
.btns {
  position: absolute;
  top: 60px;
  left: 35px;
  /* width: 90px; */
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  z-index: 5
  /* display: none; */
}
.btns > div {
  width: 45px;
  height: 25px;
  margin: 0 4px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
  border-radius: 8px;
  color: #fff;
  background-color: #065550;
  cursor: pointer;
}
.btns>.on{
  background-color: #01D197;
}
.l-top-title {
  padding: 0 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  height: 50px;
  padding-left: 30px;
  color: #fff;
}
.l-top-title > li {
  height: 30px;
  line-height: 30px;
  display: flex;
  justify-items: center;
  font-size: 14px;
}
.l-top-title > li > input,
.l-top-title > li > select {
  height: 100%;
  outline: none;
  border: none;
  background-color: #00413c;
  color: #fff;
}
.l-top-title > li > select {
  text-align: center;
  margin: 0 10px;
}
.searchs {
  border-radius: 8px;
  padding-left: 8px;
}
button {
  width: 60px;
  text-align: center;
  background-color: #05affc;
  color: #fff;
  outline: none;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  margin-left: 15px;
}
.nav-title {
  height: 50px;
  padding: 0 50px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  position: relative;
}
.title2 {
  position: absolute;
  top: 12px;
  right: 10px;
}
.title2 > li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #fff;
  margin-right: 10px;
}
.title2 > li > i {
  display: block;
  height: 20px;
  width: 20px;
  margin-right: 5px;
}
.title2 > li:first-child i {
  background: url("../assets/img/icon-tpz.png") no-repeat;
  background-size: 100% 100%;
}
.title2 > li:nth-child(2) i {
  background: url("../assets/img/icon-stp.png") no-repeat;
  background-size: 100% 100%;
}
.title2 > li:nth-child(3) i {
  background: url("../assets/img/icon-md.png") no-repeat;
  background-size: 100% 100%;
}
.nav-title > ul {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
.title1 > li {
  height: 30px;
  line-height: 30px;
  width: 60px;
  text-align: center;
  background-color: #065550;
  color: #fff;
  border-radius: 8px;
  margin-left: 8px;
  cursor: pointer;
}
.title1 > .on {
  background: #01d197;
}
.title1 > li:first-child {
  margin: 0;
}
.l-top-nav {
  /* border: 1px solid red;
  box-sizing: border-box; */
  height: 400px;
  width: 930px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  background-color: #999;
}
.shelves {
  text-align: center;
  /* width: 900px;
  height: 246px; */
  position: absolute;
  border: 1px solid #57a3f3;
  box-sizing: border-box;
  background-color: #071f37;
  display: flex;
  flex-direction: column;
  justify-content: start;
  flex-wrap: wrap;
}
.shelves > div {
  /* width: 10px;
  height: 10px; */
  line-height: 14px;
  color: #666;
  /* margin: 7px 0 0 3px; */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.shelves > div > div{
  width: 7px;
  height: 7px;
}
/* 货位标记 */
.state-jy {
  background: url("../assets/img/icon-jy.png") no-repeat;
  background-size: 100% 100%;
}
.state-zs {
  background: url("../assets/img/icon-zs.png") no-repeat;
  background-size: 100% 100%;
}
.state-kcbkr {
  background: url("../assets/img/icon-kcbkr.png") no-repeat;
  background-size: 100% 100%;
}
.state-krbkc {
  background: url("../assets/img/icon-krbkc.png") no-repeat;
  background-size: 100% 100%;
}
.state-ky {
  background: url("../assets/img/icon-ky.png") no-repeat;
  background-size: 100% 100%;
}

/* 货位状态 */
.KeyCord>.state1-drk{
  background: url("../assets/img/icon-drk.png") no-repeat;
  background-size: 100% 100%;
}
.KeyCord>.state1-dck{
  background: url("../assets/img/icon-dck.png") no-repeat;
  background-size: 100% 100%;
}
.KeyCord>.state1-ycc{
  background: url("../assets/img/icon-ycc.png") no-repeat;
  background-size: 100% 100%;
}
.KeyCord>.state1-k{
  background: url("../assets/img/icon-k.png") no-repeat;
  background-size: 100% 100%;
}
.KeyCord>.state1-bl{
  background: url("../assets/img/icon-bl.png") no-repeat;
  background-size: 100% 100%;
}


/* 物料类型 */
.state-tpz{
  background: url("../assets/img/icon-tpz.png") no-repeat;
  background-size: 100% 100%;
}
.state-stp{
  background: url("../assets/img/icon-stp.png") no-repeat;
  background-size: 100% 100%;
}
.l-top-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  height: 50px;
  padding: 0 30px;
}
.l-top-bottom > li,
.l-top-bottom > li > ul {
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: row;
  color: #fff;
}
.l-top-bottom > li > ul > li {
  margin-left: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.l-top-bottom > li > ul > li > i {
  display: block;
  height: 20px;
  width: 20px;
}
.hwzt > li:first-child i {
  background: url("../assets/img/icon-drk.png") no-repeat;
  background-size: 100% 100%;
}
.hwzt > li:nth-child(2) i {
  background: url("../assets/img/icon-dck.png") no-repeat;
  background-size: 100% 100%;
}
.hwzt > li:nth-child(3) i {
  background: url("../assets/img/icon-ycc.png") no-repeat;
  background-size: 100% 100%;
}
.hwzt > li:nth-child(4) i {
  background: url("../assets/img/icon-k.png") no-repeat;
  background-size: 100% 100%;
}
.hwzt > li:nth-child(5) i {
  background: url("../assets/img/icon-bl.png") no-repeat;
  background-size: 100% 100%;
}
.hwbj > li:first-child i {
  background: url("../assets/img/icon-jy.png") no-repeat;
  background-size: 100% 100%;
}
.hwbj > li:nth-child(2) i {
  background: url("../assets/img/icon-zs.png") no-repeat;
  background-size: 100% 100%;
}
.hwbj > li:nth-child(3) i {
  background: url("../assets/img/icon-kcbkr.png") no-repeat;
  background-size: 100% 100%;
}
.hwbj > li:nth-child(4) i {
  background: url("../assets/img/icon-krbkc.png") no-repeat;
  background-size: 100% 100%;
}
.hwbj > li:nth-child(5) i {
  background: url("../assets/img/icon-ky.png") no-repeat;
  background-size: 100% 100%;
}
/* **** */
.l-bottom {
  width: 100%;
  height: calc(100% - 567px);
  /* border: 1px solid red;
  box-sizing: border-box; */
  display: flex;
  justify-content: space-between;
}

.right {
  width: calc(100% - 1010px);
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
}
.right > div {
  width: calc(50% - 5px);
  height: calc(50% - 5px);
  background-color: #fff;
  border: 1px solid #0f5b68;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right > div:last-child {
  margin-top: 10px;
}
.right > div:nth-child(3) {
  margin-top: 10px;
}
.div1,
.div2 {
  display: flex;
  align-items: center;
}
.el-message-box__wrapper{
    position: fixed;
    top: 0;
    /* bottom: 0; */
    left: 0;
    right: 0;
    text-align: center;
    height: 853px!important;
}
</style>




// WEBPACK FOOTER //
// src/components/xiayan/home/Stock.vue